import { FACE_EXPENSES_FAILED, FACE_EXPENSES_REQUEST, FACE_EXPENSES_SUCCESS } from "app/redux/actions/Master/Expenses/FaceExpenses/constant";


const INIT_STATE = {
    loading: false,
    totalPage: 0,
    data: [],
    error: {
        isError: false,
        message: null
    }
};

export const faceExpensesReducer = function (state = INIT_STATE, action) {
    switch (action?.type) {
        case FACE_EXPENSES_REQUEST:
            return {
                loading: true,
                totalPage: 0,
                data: [],
                error: {
                    isError: false,
                    message: null
                }
            }
        case FACE_EXPENSES_SUCCESS:
            return {
                loading: false,
                data: action?.payload?.data,
                totalPage: action?.payload?.totalPage,
                error: {
                    isError: false,
                    message: null
                }
            }
        case FACE_EXPENSES_FAILED:
            const { isError = true, message = "Something Went Wrong" } = action?.payload?.error || {}
            return {
                loading: false,
                totalPage: 0,
                data: [],
                error: {
                    isError: isError,
                    message: message
                }
            }
        default:
            return state;
    }
};